import { useState, useEffect, useRef } from "react";
import tw from "tailwind-styled-components";
import {
  BoxContainer,
  Underline,
  BoxTitle,
  BoxHead,
  FilterTableWrapper,
  FilterWrapper,
} from "../../Components/Styles/PageStyles";
import { useSelector } from "react-redux";
import { Form, Formik } from "formik";
import Table from "../../Components/Properties/UnAvailableTable";
import SearchFilterBox from "../../Components/SearchFilterBox";
import SideModal from "../../Components/SideModal";
import AddPropertyPage from "../../Components/AddBrokerProperty/AddPropertyPage";
import ViewDetails from "../../Components/AddBrokerProperty/ViewDetails";
import InventoryFilterModal from "../../Components/Properties/InventoryFilterModal";
import ViewDealsModal from "../../Components/Properties/ViewDealsModal";
import ViewTenantModal from "../../Components/Properties/ViewTenantModal";
import LinkStaff from "../../Components/Properties/LinkStaff";
import AddTenant from "../../Components/Properties/AddTenant";
import axios from "axios";
import Config from "../../Config";
import { toast } from "react-toastify";
import { useMutation } from "react-query";
import NotFoundModel from "../../Components/NotFoundModel";
import Loading from "../../Components/Loading";
import moment from "moment";
import DateRange from "../../Components/DateRange";
import { AddBtn } from "../../Components/Styles/InputStyles";
import { IoFilter } from "react-icons/io5";

const UnAvailableInventory = () => {
  const btnRef = useRef(null);
  const [activeFilter, setActiveFilter] = useState({
    value: "",
    label: "",
    title: "",
  });
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const [filteredData, setFilteredData] = useState(null);
  const searchOptions = [{ label: "Name", value: 1 }];
  const user = useSelector((state) => state.UserReducer.user);
  const [selectedData, setSelectedData] = useState("");
  const [selectedId, setSelectedId] = useState(null);
  const [isFocused, setIsFocused] = useState(false);
  const [selectedTab, setSelectedTab] = useState(1);
  // const [staffList, setStaffList] = useState(null);
  const [apiData, setApiData] = useState(null);
  const [isAddProperty, setIsAddProperty] = useState(false);
  const [viewDetail, setViewDetail] = useState(false);
  const [step, setStep] = useState(1);
  const [showViewDeals, setShowViewDeals] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [filterType, setFilterType] = useState("");
  const [dealList, setDealList] = useState([]);
  const [staffList, setStaffList] = useState();
  const [activeTab, setActiveTab] = useState("1");
  const [isFilterApplied, setIsFilterApplied] = useState(false);
  const [tenantData, setTenantData] = useState(null);

  //--Date filter---
  const [startDate, setStartDate] = useState(
    moment().startOf("month").format("YYYY-MM-DD")
  );
  const [endDate, setEndDate] = useState(
    moment().endOf("month").format("YYYY-MM-DD")
  );

  const fetchInventoryList = async (params) => {
    const query = `&s=${params.searchQuery || ""}&t=${params.filterType || ""}&startDate=${params.startDate || ""}&endDate=${params.endDate || ""}`;

    const response = await axios.get(
      `${Config.apiUrl}/inventory/list/unavailable?${query}`,
      {
        headers: {
          authorization: `Bearer ${user.token}`,
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
        },
      }
    );

    return response.data;
  };

  const getInventorySuccess = (res) => {

    if (res?.isSuccess) {
      setApiData(res?.data || []);
      setFilteredData(res?.data || []);
      //setSummaryData(res?.summary || null);
      setStaffList(res?.staffList || []);
      setIsFocused(true);
    }
  };

  const getInventoryError = (err) => {
    toast.error(err?.response?.data?.msg || "An Error Occured");
  };

  const {
    isLoading,
    mutate: getInventoryMutate,
    error,
    isRefetching,
    data,
  } = useMutation(fetchInventoryList, {
    onSuccess: getInventorySuccess,
    onError: getInventoryError,
  });

  useEffect(() => {
    getInventoryMutate({
      searchQuery: "",
      filterType: "",
      startDate,
      endDate
    });
  }, []);

  // ------- Update Inventory Status -------
  const updateStatusFunction = async (values) => {
    return await axios.post(
      `${Config.apiUrl}/inventory/update/status`,
      values,
      {
        headers: {
          "Content-Type": "application/json",
          authorization: `Bearer ${user.token}`,
        },
      }
    );
  };

  const updateStatusSuccess = (data) => {
    toast.success(data?.data?.msg || "Status updated");

    getInventoryMutate({ searchQuery, filterType, startDate, endDate });
  };

  const updateStatusError = (err) => {
    toast.error(err?.response?.data?.msg || "Error updating status");
  };

  const { mutate: updateStatusMutate } = useMutation(updateStatusFunction, {
    onSuccess: updateStatusSuccess,
    onError: updateStatusError,
  });

  // useEffect(() => {
  //   if (!apiData) return;

  //   if (!isFilterApplied) {
  //     let filtered = [...apiData];

  //     switch (activeTab) {
  //       case "1": // Available
  //         filtered = apiData.filter(
  //           item => item.status === Config.INVENTORY_STATUS.AVAILABLE
  //         );
  //         break;

  //       case "2": // Booked
  //         filtered = apiData.filter(
  //           item => item.status === Config.INVENTORY_STATUS.BOOKED
  //         );
  //         break;

  //       case "3": // Leased
  //         filtered = apiData.filter(
  //           item => item.status === Config.INVENTORY_STATUS.LEASED
  //         );
  //         break;

  //       case "4": // Hold
  //         filtered = apiData.filter(
  //           item => item.status === Config.INVENTORY_STATUS.HOLD
  //         );
  //         break;

  //       default:
  //         filtered = apiData;
  //     }

  //     setFilteredData(filtered);
  //   }
  // }, [activeTab, apiData, isFilterApplied]);

  const handleTabChange = (tab) => {
    setActiveTab(tab);
    setSelectedId(null);
    setSelectedTab(tab);
    if (isFilterApplied) {
      setIsFilterApplied(false);
      setActiveFilter(null);
    }
  };

  const getAvailableCount = () => {
    if (!apiData) return 0;
    return apiData.filter(
      item => item.status === Config.INVENTORY_STATUS.AVAILABLE
    ).length;
  };

  const getClosedCount = () => {
    if (!apiData) return 0;
    return apiData.filter(
      item => item.status === Config.INVENTORY_STATUS.BOOKED
    ).length;
  };

  const getLeasedCount = () => {
    if (!apiData) return 0;
    return apiData.filter(
      item => item.status === Config.INVENTORY_STATUS.LEASED
    ).length;
  };

  const getHoldCount = () => {
    if (!apiData) return 0;
    return apiData.filter(
      item => item.status === Config.INVENTORY_STATUS.HOLD
    ).length;
  };

  const summaryCounts = {
    available: getAvailableCount(),
    closed: getClosedCount(),
    leased: getLeasedCount(),
    hold: getHoldCount(),
  };

  const handleFilterChange = (values) => {
    setFilterType(values.filterType);
    setSearchQuery(values.searchQuery);

    getInventoryMutate({
      searchQuery: values.searchQuery,
      filterType: values.filterType,
      startDate,
      endDate
    });
  };

  const handleClearFilter = () => {
    setFilterType("");
    setSearchQuery("");

    getInventoryMutate({
      searchQuery: "",
      filterType: "",
      startDate,
      endDate
    });
  };

  const handleApplyFilter = (filterValue, filterLabel, filterType) => {
    if (!apiData) return;

    let filtered = [...apiData];

    if (filterType === "Status") {
      filtered = apiData.filter(item => item.availabilityStatus === filterLabel.toLowerCase());
    } else if (filterType === "Property Type") {
      filtered = apiData.filter(item => item.propertyType === filterLabel.toLowerCase());
    } else if (filterType === "Locality") {
      const locationId = parseInt(filterValue.replace('LOC_', ''));
      filtered = apiData.filter(item => item.locationId === locationId);
    }

    setFilteredData(filtered);
    setActiveFilter({ value: filterValue, label: filterLabel, type: filterType });
    setIsFilterOpen(false);
  };

  const handleClearFilters = () => {
    setFilteredData(apiData);
    setActiveFilter(null);
  };

  const handleCloseViewDeals = () => {
    setShowViewDeals(false);
  };

  return (
    <>
      <BoxContainer>
        <BoxHead>
          <BoxTitle className="!mb-0 whitespace-nowrap">
            Unavailable Inventory
            <Underline />
          </BoxTitle>
          {/* <Filters setIsAddProperty={setIsAddProperty} /> */}
        </BoxHead>
        <SideModal
          isOpen={isFilterOpen}
          onClose={() => setIsFilterOpen(false)}
        >
          <InventoryFilterModal
            onApplyFilter={handleApplyFilter}
            handleClose={() => setIsFilterOpen(false)}
            currentFilter={activeFilter}
            handleClearFilters={handleClearFilters}
          />

        </SideModal>

        <SideModal
          isOpen={isAddProperty}
          onClose={() => {
            setIsAddProperty(false);
            setStep(1);
          }}
        >
          <AddPropertyPage
            setIsAddProperty={setIsAddProperty}
            isAddProperty={isAddProperty}
            step={step}
            setStep={setStep}
            selectedData={selectedData}
            user={user}
            getListMutate={getInventoryMutate}
          />
        </SideModal>

        <SideModal
          isOpen={viewDetail}
          onClose={() => {
            setViewDetail(false);
          }}
        >
          <ViewDetails
            setViewDetail={setViewDetail}
            viewDetail={viewDetail}
            selectedData={selectedData}
          />
        </SideModal>

        {/* <>
          {!isFocused && <SummarySkeletonLoading count={4} />}
          {isFocused && summaryCounts && (
            <SummaryCards
              summaryData={summaryCounts}
              setSelectedId={setSelectedId}
              selectedId={selectedId}
            />
          )}
        </> */}

        <FilterTableWrapper>
          <FilterWrapper>
            <div className="flex md:space-x-4 md:flex-row flex-col md:gap-0 gap-4">
              <SearchFilterBox
                options={searchOptions}
                handleFilterChange={handleFilterChange}
                handleClearFilters={handleClearFilter}
              />
              <DateRange
                submitHandler={(values) => {
                  const formattedStart = moment(values.startDate).format("YYYY-MM-DD");
                  const formattedEnd = moment(values.endDate).format("YYYY-MM-DD");
                  setStartDate(formattedStart);
                  setEndDate(formattedEnd);
                  getInventoryMutate({
                    searchQuery,
                    filterType,
                    startDate: formattedStart,
                    endDate: formattedEnd,
                  });
                }}
                defaultLabel={`${moment(startDate).format("DD MMM yyyy")} - ${moment(endDate).format("DD MMM yyyy")}`}
              />
            </div>

            <div className="flex gap-2 justify-end items-center">

              {/* <div className="relative">
                <FilterBtn
                  ref={btnRef}
                  type="button"
                  title="Tenant Filter"
                  onClick={() => setIsFilterOpen((v) => !v)}
                >
                  <IoFilter size={14} color="#9CA3AF" />
                  {activeFilter?.value && (
                    <span className="absolute -top-1 -right-1 h-2.5 w-2.5 rounded-full bg-yellow-500 border border-white" />
                  )}
                </FilterBtn>
              </div> */}
            </div>
          </FilterWrapper>

          {!error && !isLoading && apiData && (
            <TableWrapper>
              <Table
                apiData={filteredData}
                setSelectedData={setSelectedData}
                selectedData={selectedData}
                setViewDetail={setViewDetail}
                setShowViewDeals={setShowViewDeals}
                updateStatusMutate={updateStatusMutate}
                // getDealListMutate={getDealListMutate}
                //dealLoading={dealLoading}
                selectedTab={Number(selectedTab)}
              />
              {(!filteredData || filteredData.length === 0) && <NotFoundModel />}
            </TableWrapper>
          )}
        </FilterTableWrapper>
        {error && !isLoading && <NotFoundModel />}
        {(isLoading || isRefetching) && <Loading />}
      </BoxContainer>
    </>
  );
};

const Filters = ({ setIsAddProperty }) => {
  return (
    <Formik>
      <Form>
        <FilterContainer>
          <AddBtn
            type="button"
            onClick={() => {
              setIsAddProperty(true);
            }}
          >
            {"Add Inventory"}
          </AddBtn>
        </FilterContainer>
      </Form>
    </Formik>
  );
};

const TableWrapper = tw.h1`mt-4 bg-white rounded-md`;
const FloorTabs = tw.div`flex overflow-x-auto bg-white rounded-md my-4 border-b`;

const FloorTab = tw.button`
  ${(p) =>
    p.$active
      ? " text-primary-color border-b-2 border-b-primary-color bg-cyan-50 "
      : " text-gray-700 "} 
  px-5 py-3 cursor-pointer font-medium transition-all duration-200 whitespace-nowrap text-sm
`;
const FilterContainer = tw.div`
    grid grid-cols-2 w-full gap-4 md:flex md:space-x-4 items-end mt-0 md:mt-0`;
const FilterBtn = tw.button`flex items-center border whitespace-nowrap border-gray-300 justify-center rounded-md px-4 cursor-pointer bg-white hover:bg-gray-200 h-10 text-sm ml-auto`;

export default UnAvailableInventory;